module.exports = __webpack_public_path__ + "img/img28.fe34a964.png";